
import React from "react"
import { Link } from "react-router-dom/cjs/react-router-dom";
import { Container, Grid, Header, List, Segment } from "semantic-ui-react";
import MenuHeader from '../navbar.jsx';
import DisplayMessage from "../../commons/displayMessage.jsx";
import { Icon } from 'semantic-ui-react'
import PageHeader from "../PageHeader.jsx";
import { BrowserRouter as Router } from "react-router-dom"
import { useTranslation } from "react-i18next";
import Footer from "../footer.jsx";
function PrivacyPolicyPage() {
  const { t } = useTranslation()
  const cardStyle = {
    height: "100%",
    borderRadius: "7px",
    padding: "17px",
  };
  const iconStyle = {
    marginBottom: "10px",
  };

  return (
    <>
      <Grid>
        <Grid.Column width={16} className="pb-0">
          <MenuHeader />
        </Grid.Column>
      </Grid>
      <Container style={{ paddingTop: "50px", paddingBottom: "50px" }}>
        <PageHeader />
        {/* <DisplayMessage context={this} messageType={this.state.messageType} messageHeader={this.state.messageHeader} message={this.state.message} /> */}
        {/* Top Content */}
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <Header as="h1">Your Privacy at a Glance</Header>

          <p
            style={{
              maxWidth: "850px",
              margin: "15px auto",
              color: "#666",
              lineHeight: "28px",
            }}
          >
            Hello! Welcome to the DCN.scot privacy policy.
            We want to make it easy for you to understand how we
            handle your information. Here's a quick overview of
            how we protect your data and respect your privacy.
          </p>
        </div>

        <Grid stackable columns={2}>
          {/* Card 1 */}
          <Grid.Column>
            <Segment raised style={cardStyle}>
              {/* <ArrowDown size={42}  /> */}
              <div style={{ textAlign: "center" }}>
                <Icon name='download' size='huge' style={iconStyle} />
                <Header as="h2">
                  Types of data we collect
                </Header>
              </div>
              <List bulleted>
                <List.Item>
                  Personal data you give us when you register
                  for an account
                </List.Item>

                <List.Item>
                  Personal data you give us when you raise a
                  query with us
                </List.Item>

                <List.Item>
                  Personal data we collect about you when you
                  use the service
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment raised style={cardStyle}>
              {/* <Code size={42} style={iconStyle} /> */}
              <div style={{ textAlign: "center" }}>
                <Icon name='code' size='huge' style={iconStyle} />
                <Header as="h2">
                  We use cookies...mmm cookie, not that kind
                </Header>
              </div>
              <List bulleted>
                <List.Item>
                  We use necessary cookies to run and secure
                  the service
                </List.Item>

                <List.Item>
                  Cookies help protect your account and improve
                  performance
                </List.Item>

                <List.Item>
                  Cookies do not personally identify you on
                  their own
                </List.Item>

                <List.Item>
                  You can block cookies, but parts of the
                  service may not work
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment raised style={cardStyle}>
              {/* <Check square outline style={iconStyle} /> */}
              <div style={{ textAlign: "center" }}>
                <Icon name='check' bordered size='huge' style={iconStyle} />
                <Header as="h2">Know your rights</Header>
              </div>
              <List bulleted>
                <List.Item>
                  Access the information we hold about you
                </List.Item>

                <List.Item>
                  Correct or update your details
                </List.Item>

                <List.Item>
                  Close your account and request deletion of
                  your data
                </List.Item>

                <List.Item>
                  Restrict or object to how your data is
                  processed
                </List.Item>

                <List.Item>
                  Request deletion in line with Data Retention
                  Policy
                </List.Item>

                <List.Item>
                  Raise a complaint with the ICO
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment raised style={cardStyle}>
              {/* <users size={42} style={iconStyle} /> */}
              <div style={{ textAlign: "center" }}>
                <Icon name='users' size='huge' style={iconStyle} />
                <Header as="h2">
                  Third parties who process your data
                </Header>
              </div>
              <List bulleted>
                <List.Item>
                  Infrastructure: Brightsolid UK, Tata
                  Consultancy Services
                </List.Item>

                <List.Item>
                  Public sector partners: Scottish Government,
                  Local Authorities
                </List.Item>

                <List.Item>
                  Support (if required): Local Authorities
                </List.Item>

                <List.Item>
                  Security & fraud prevention where legally
                  required
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment raised style={cardStyle}>
              {/* <Settings size={42} style={iconStyle} /> */}
              <div style={{ textAlign: "center" }}>
                <Icon name='settings' size='huge' style={iconStyle} />
                <Header as="h2">How we use your data</Header>
              </div>
              <List bulleted>
                <List.Item>
                  Deliver the datapipeline.scot service
                </List.Item>

                <List.Item>
                  Verify and manage access
                </List.Item>

                <List.Item>
                  Provide user support and respond to queries
                </List.Item>

                <List.Item>
                  Develop and improve the services that we
                  offer
                </List.Item>

                <List.Item>
                  Keep the service secure and reliable
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment raised style={cardStyle}>
              <Grid>
                {/* Left */}
                <Grid.Column width={3}>
                  <div style={{ textAlign: "center" }}>
                    <h4 style={{ color: "green" }}>
                      Data You
                      <br />
                      Give
                    </h4>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "18px",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          width: "2px",
                          background: "green",
                          top: 0,
                          bottom: 0,
                        }}
                      />

                      {[1, 2, 3, 4, 5].map((item) => (
                        <div
                          key={item}
                          style={{
                            width: "24px",
                            height: "24px",
                            border: "2px solid green",
                            borderRadius: "50%",
                            background: "white",
                            zIndex: 1,
                          }}
                        />
                      ))}
                    </div>
                  </div>
                </Grid.Column>

                {/* Middle */}
                <Grid.Column width={3}>
                  <div style={{ textAlign: "center" }}>
                    <h4 style={{ color: "#2185d0" }}>
                      Data We
                      <br />
                      Collect
                    </h4>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "18px",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          width: "2px",
                          background: "#2185d0",
                          top: 0,
                          bottom: 0,
                        }}
                      />

                      {[1, 2, 3, 4, 5].map((item) => (
                        <div
                          key={item}
                          style={{
                            width: "24px",
                            height: "24px",
                            border: "2px solid #2185d0",
                            borderRadius: "50%",
                            background: "white",
                            zIndex: 1,
                          }}
                        />
                      ))}
                    </div>
                  </div>
                </Grid.Column>
                {/* Right */}
                <Grid.Column width={10}>
                  <List bulleted size="large">
                    <List.Item>
                      You are registered as an agent
                    </List.Item>

                    <List.Item>
                      You sign in to datapipeline
                    </List.Item>

                    <List.Item>
                      You browse datapipeline
                    </List.Item>

                    <List.Item>
                      You process data
                    </List.Item>

                    <List.Item>
                      You access the service using any device
                    </List.Item>

                    <List.Item>
                      You raise a support request
                    </List.Item>
                  </List>
                </Grid.Column>
              </Grid>
            </Segment>
          </Grid.Column>

        </Grid>

        <div
          style={{
            marginTop: "50px",
            textAlign: "center",
            borderTop: "1px solid #e5e5e5",
            paddingTop: "30px",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              marginBottom: "15px",
            }}
          >
            Want to know more?{" "}

            {/* <a
              href="#"
              style={{
                color: "#2185d0",
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              Read the policy here
            </a> */}
            <Link className='customLink' to="/privacyPolicy">Read the policy here</Link>

          </p>

          <p
            style={{
              fontSize: "14px",
              color: "#666",
              lineHeight: "24px",
              maxWidth: "850px",
              margin: "0 auto",
              marginBottom: "10px"
            }}
          >
            If you have any concerns about your privacy at
            DCN.scot, please contact our support
            team.
          </p>
        </div>

        <Footer />
      </Container>
    </>
  )
}

export default PrivacyPolicyPage